import { render, staticRenderFns } from "./CreateInvestorAccount.vue?vue&type=template&id=1eeba156"
import script from "./CreateInvestorAccount.vue?vue&type=script&lang=js"
export * from "./CreateInvestorAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports